import { useRef, useState } from "react";
import { History } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useHermes } from "./HermesProvider";
import { HermesSessionList } from "./HermesSessionList";

/** 抽屉态 header：会话列表 Popover（紧凑入口）。 */
export function HermesSessionsMenu() {
  const { accountId } = useHermes();
  const [open, setOpen] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>(null);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className="size-7"
          aria-label="会话列表"
          disabled={!accountId}
        >
          <History className="size-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-72 p-0"
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          searchInputRef.current?.focus();
        }}
        onCloseAutoFocus={(event) => {
          // 选会话/新建后由抽屉聚焦右侧输入框，勿归还到 History 触发器
          event.preventDefault();
        }}
      >
        <HermesSessionList
          enabled={open}
          variant="popover"
          searchInputRef={searchInputRef}
          onSessionChosen={() => setOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
}
